<template>
  <el-input v-model="real_amount_thousand" :disabled="disabled" v-if="isThousand" @focus="focusInput()"></el-input>
  <el-input-number
    style="width: 100%"
    :precision="2"
    v-model="numberVal"
    v-else
    :min="0"
    :max="9999999999"
    :controls="false"
    @blur="blurInput()"
    type="number"
    :disabled="disabled"
  ></el-input-number>
</template>
<script>
import utils from '@/utils.js'
export default {
  data() {
    return {
      isThousand: true,
      real_amount_thousand: '0.00'
    }
  },
  props: {
    numberVal: {
      type: Number,
      default: () => 0
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    keyName: {
      type: String,
      default: () => ''
    }
  },
  watch: {
    numberVal: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal || newVal == 0) {
          this.real_amount_thousand = utils.dataTransform(this.numberVal)
        }
      }
    }
  },
  methods: {
    // 失焦
    blurInput() {
      this.isThousand = true
      if (this.numberVal || this.numberVal == 0) {
        this.numberVal = Number(this.numberVal).toFixed(2)
        this.real_amount_thousand = utils.dataTransform(this.numberVal)
      }
      this.$emit('setVal', this.keyName, this.numberVal)
    },
    // 聚焦
    focusInput() {
      this.isThousand = false
    }
  }
}
</script>
